import React, { type ReactElement, type ReactNode } from 'react';
import { LayoutType } from '../../../../utils/enums/layout-type.enum';
import DashboardLayoutV1 from '../DashboardLayout/DashboardLayout';
import DefaultLayoutV1 from '../DefaultLayout/DefaultLayout';
import BlankLayoutV1 from '../BlankLayout/BlankLayout';

const Layouts = {
  [LayoutType.DASHBOARDV1]: DashboardLayoutV1,
  [LayoutType.DEFAULTV1]: DefaultLayoutV1,
  [LayoutType.BLANKLAYOUTV1]: BlankLayoutV1,
};

interface AppLayoutProps {
  layout: LayoutType;
  children: ReactNode;
  [key: string]: any;
}

function AppLayout({ layout, children, ...restProps }: AppLayoutProps): ReactElement {
  const Layout = Layouts[layout];

  return <Layout {...restProps}>{children}</Layout>;
}

export default AppLayout;
